





































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations, Hococo, FormModes } from '@/ts/store/Constants';
import { debounce } from 'lodash';
import BuildingManagerSuggestions from '@/components/Admin/Layout/BuildingManagerSuggestions.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';

@Component({
    computed: {
        ...mapGetters({
            formVisible: 'Viewport/isEditFormVisible',
            suggestions: 'Buildings/getManagerSuggestions',
        }),
    },
    components: {
        BuildingManagerSuggestions,
    },
})
export default class EditBuildingForm extends Mixins(InputFieldMethods) {
    @Prop() public formMode: string;
    public searchQuery: string = '';
    public queryDebounceManager: any | null;
    public queryDebounceStaff: any | null;

    constructor() {
        super();

        this.queryDebounceManager = debounce(() => {
            this.queryManager();
        }, Hococo.SUGGESTION_DEBOUNCE_PERIOD);
    }

    get errorCollection() {
        return this.errors.any();
    }

    get isEditing() {
        return (this.formMode === FormModes.Edit);
    }

    get isCreating() {
        return (this.formMode === FormModes.Create);
    }

    get managerName() {
        return (userId: number) => {
            return this.$store.getters['User/getCacheUser'](userId).fullName;
        };
    }

    get activeBuilding() {
        if (this.$store.state.Buildings.activeBuildingId === null) {
            return;
        }

        return this.$store.state.Buildings.buildings[
                            this.$store.state.Buildings.buildingsMap[
                                this.$store.state.Buildings.activeBuildingId]];
    }

    get suggestionsVisible() {
        return this.$store.getters['Buildings/userSuggestionsVisible'];
    }

    get getProjectsData(): any {
        return this.$store.getters['Projects/allProjects'];
    }

    get buildingData(): any {
        return this.$store.getters['Buildings/allBuildings'];
    }

    get buildingProject(): number {
        return this.$store.getters['Buildings/getBuildingProject'];
    }

    set buildingProject(value: number) {
        this.$store.commit(Mutations.UPDATE_BUILDING_PROJECT_ID, value);
        return;
    }

    get buildingName(): string {
        return this.$store.getters['Buildings/getBuildingName'];
    }

    set buildingName(value: string) {
        this.$store.commit(Mutations.UPDATE_BUILDING_NAME, value);
        return;
    }

    public dataLoaded(): boolean {
        return (this.buildingData);
    }

    get managerSearchQuery(): string {
        return this.$store.state.Buildings.managerSearchQuery;
    }

    set managerSearchQuery(value: string) {
        this.$store.commit(Mutations.SET_MANAGER_SEARCH_QUERY, value);
    }

    public queryManager(): void {
        this.$store.dispatch(Actions.QUERY_MANAGER_SUGGESTIONS, this.managerSearchQuery);
        this.$store.commit(Mutations.SHOW_BUILDING_USER_SUGGESTIONS);
    }

    get buildingStaff(): number {
        return this.$store.getters['Buildings/getBuildingStaff'];
    }

    set buildingStaff(value: number) {
        this.$store.commit(Mutations.UPDATE_BUILDING_STAFF, value);
        return;
    }

    get buildingManagerName(): string {
        return this.$store.getters['Buildings/getBuildingManagerName'];
    }

    get buildingStaffName(): string {
        return this.$store.getters['Buildings/getBuildingStaffName'];
    }

    public cancel() {
        if (this.isCreating) {
            this.$store.dispatch(Actions.HIDE_FORM);

            this.buildingProject = null;
            this.buildingName = '';
            this.managerSearchQuery = '';
            this.buildingStaff = null;

            this.$nextTick(() => {
                this.errors.clear();
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            });
        }

        if (this.isEditing) {
            this.$store.commit(Mutations.CANCEL_EDIT_BUILDING);
            this.$store.commit(Mutations.HIDE_EDIT_BUILDING_FORM);
        }
    }

    public edit() {
        this.$store.commit(Mutations.HIDE_EDIT_BUILDING_FORM);
        this.$store.dispatch(Actions.EDIT_BUILDING);
    }

    public create() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                this.$store.dispatch(Actions.HIDE_FORM);
                this.$store.dispatch(Actions.POST_BUILDINGS);
            }
        });
    }

    public removeManager(managerId: number) {
        this.$store.commit(Mutations.REMOVE_MANAGER_FROM_ACTIVE_BUILDING, managerId);
    }

    public mounted() {
        this.$store.dispatch(Actions.FETCH_PROJECTS);
    }
}
